// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pricing page specific styles */

/* Pricing Grid */
.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.pricing-card {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-xl);
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.pricing-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.pricing-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
  border-color: var(--accent-blue);
}

.pricing-card:hover::before {
  transform: scaleX(1);
}

.pricing-card.featured {
  border-color: var(--accent-blue);
  box-shadow: var(--shadow-lg);
  transform: scale(1.05);
}

.pricing-card.featured::before {
  transform: scaleX(1);
}

.popular-badge {
  position: absolute;
  top: -1px;
  right: var(--space-lg);
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white);
  padding: var(--space-xs) var(--space-md);
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.pricing-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.price {
  font-size: 3rem;
  font-weight: 700;
  color: var(--accent-blue);
  margin-bottom: var(--space-sm);
}

.price span {
  font-size: 1rem;
  color: var(--gray-600);
  font-weight: 400;
}

.plan-description {
  color: var(--gray-600);
  margin-bottom: var(--space-lg);
  font-size: 0.95rem;
}

.introductory-pricing {
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white);
  padding: var(--space-md);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-lg);
  text-align: center;
}

.introductory-pricing p {
  margin: 0;
  font-size: 0.9rem;
}

.introductory-pricing p:first-child {
  font-weight: 600;
  margin-bottom: var(--space-xs);
}

.introductory-pricing p:last-child {
  font-size: 0.8rem;
  opacity: 0.9;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-xl) 0;
  text-align: left;
}

.pricing-features li {
  padding: var(--space-xs) 0;
  color: var(--gray-600);
  position: relative;
  padding-left: var(--space-lg);
}

.pricing-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--teal);
  font-weight: bold;
  font-size: 1.1rem;
}

/* Development Pricing */
.development-pricing {
  margin-top: var(--space-2xl);
}

.dev-pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--space-xl);
}

.dev-pricing-card {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-xl);
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.dev-pricing-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  border-color: var(--accent-blue);
}

.dev-pricing-card h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.dev-pricing-card .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--accent-blue);
  margin-bottom: var(--space-sm);
}

.dev-pricing-card .price span {
  font-size: 0.9rem;
  color: var(--gray-600);
  font-weight: 400;
}

/* Maintenance Pricing */
.maintenance-pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.maintenance-pricing-card {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-xl);
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  position: relative;
}

.maintenance-pricing-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  border-color: var(--accent-blue);
}

.maintenance-pricing-card.featured {
  border-color: var(--accent-blue);
  box-shadow: var(--shadow-lg);
  transform: scale(1.02);
}

.maintenance-pricing-card h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.maintenance-pricing-card .price {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--accent-blue);
  margin-bottom: var(--space-sm);
}

.maintenance-pricing-card .price span {
  font-size: 0.9rem;
  color: var(--gray-600);
  font-weight: 400;
}

/* FAQ Section */
.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.faq-item {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--accent-blue);
}

.faq-item h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.faq-item p {
  color: var(--gray-600);
  line-height: 1.6;
  margin: 0;
}

/* Hourly Rates Section */
.hourly-rates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

/* For 5 cards, use 2-3 column layout */
@media (min-width: 1200px) {
  .hourly-rates-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 900px) and (max-width: 1199px) {
  .hourly-rates-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.hourly-rate-card {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-xl);
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.hourly-rate-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  border-color: var(--accent-blue);
}

.hourly-rate-card h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.hourly-price {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--accent-blue);
  margin-bottom: var(--space-sm);
}

.hourly-price span {
  font-size: 0.9rem;
  color: var(--gray-600);
  font-weight: 400;
}

.rate-description {
  color: var(--gray-600);
  margin-bottom: var(--space-lg);
  font-size: 0.95rem;
}

.rate-features {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.rate-features li {
  padding: var(--space-xs) 0;
  color: var(--gray-600);
  position: relative;
  padding-left: var(--space-lg);
}

.rate-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--teal);
  font-weight: bold;
  font-size: 1.1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .pricing-grid,
  .dev-pricing-grid,
  .maintenance-pricing-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
  
  .pricing-card.featured {
    transform: none;
  }
  
  .maintenance-pricing-card.featured {
    transform: none;
  }
  
  .faq-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
  
  .hourly-rates-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
}

/* Simplified Hourly Rate Section */
.hourly-rate-simple {
  display: flex;
  justify-content: center;
  margin-top: var(--space-2xl);
}

.hourly-rate-card-simple {
  background: var(--white);
  border: 2px solid var(--accent-blue);
  border-radius: var(--radius-xl);
  padding: var(--space-2xl);
  text-align: center;
  box-shadow: var(--shadow-lg);
  max-width: 600px;
  width: 100%;
}

.hourly-price-large {
  font-size: 3.5rem;
  font-weight: 700;
  color: var(--accent-blue);
  margin-bottom: var(--space-md);
  line-height: 1;
}

.hourly-price-large span {
  font-size: 1.5rem;
  color: var(--gray-600);
  font-weight: 500;
}

.rate-description-large {
  font-size: 1.2rem;
  color: var(--gray-700);
  margin-bottom: var(--space-xl);
  font-weight: 500;
}

.rate-services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-lg);
  margin-top: var(--space-xl);
}

.service-category {
  text-align: left;
  padding: var(--space-md);
  background: var(--gray-50);
  border-radius: var(--radius-lg);
  border-left: 4px solid var(--accent-blue);
}

.service-category h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-xs);
}

.service-category p {
  font-size: 0.95rem;
  color: var(--gray-600);
  margin: 0;
  line-height: 1.4;
}

/* Responsive adjustments for simplified hourly rates */
@media (max-width: 768px) {
  .hourly-price-large {
    font-size: 2.5rem;
  }
  
  .hourly-price-large span {
    font-size: 1.2rem;
  }
  
  .rate-description-large {
    font-size: 1.1rem;
  }
  
  .rate-services-grid {
    grid-template-columns: 1fr;
    gap: var(--space-md);
  }
  
  .hourly-rate-card-simple {
    padding: var(--space-xl);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Pricing.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4EAA4E;EAC5E,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,4EAA4E;EAC5E,mBAAmB;EACnB,wCAAwC;EACxC,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;;;IAGE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Pricing page specific styles */\n\n/* Pricing Grid */\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.pricing-card {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-xl);\n  padding: var(--space-xl);\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.pricing-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.pricing-card:hover {\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-xl);\n  border-color: var(--accent-blue);\n}\n\n.pricing-card:hover::before {\n  transform: scaleX(1);\n}\n\n.pricing-card.featured {\n  border-color: var(--accent-blue);\n  box-shadow: var(--shadow-lg);\n  transform: scale(1.05);\n}\n\n.pricing-card.featured::before {\n  transform: scaleX(1);\n}\n\n.popular-badge {\n  position: absolute;\n  top: -1px;\n  right: var(--space-lg);\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white);\n  padding: var(--space-xs) var(--space-md);\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.pricing-card h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.price {\n  font-size: 3rem;\n  font-weight: 700;\n  color: var(--accent-blue);\n  margin-bottom: var(--space-sm);\n}\n\n.price span {\n  font-size: 1rem;\n  color: var(--gray-600);\n  font-weight: 400;\n}\n\n.plan-description {\n  color: var(--gray-600);\n  margin-bottom: var(--space-lg);\n  font-size: 0.95rem;\n}\n\n.introductory-pricing {\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white);\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-lg);\n  text-align: center;\n}\n\n.introductory-pricing p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.introductory-pricing p:first-child {\n  font-weight: 600;\n  margin-bottom: var(--space-xs);\n}\n\n.introductory-pricing p:last-child {\n  font-size: 0.8rem;\n  opacity: 0.9;\n}\n\n.pricing-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 var(--space-xl) 0;\n  text-align: left;\n}\n\n.pricing-features li {\n  padding: var(--space-xs) 0;\n  color: var(--gray-600);\n  position: relative;\n  padding-left: var(--space-lg);\n}\n\n.pricing-features li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: var(--teal);\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n/* Development Pricing */\n.development-pricing {\n  margin-top: var(--space-2xl);\n}\n\n.dev-pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--space-xl);\n}\n\n.dev-pricing-card {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-xl);\n  padding: var(--space-xl);\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.dev-pricing-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--accent-blue);\n}\n\n.dev-pricing-card h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.dev-pricing-card .price {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--accent-blue);\n  margin-bottom: var(--space-sm);\n}\n\n.dev-pricing-card .price span {\n  font-size: 0.9rem;\n  color: var(--gray-600);\n  font-weight: 400;\n}\n\n/* Maintenance Pricing */\n.maintenance-pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.maintenance-pricing-card {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-xl);\n  padding: var(--space-xl);\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n}\n\n.maintenance-pricing-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--accent-blue);\n}\n\n.maintenance-pricing-card.featured {\n  border-color: var(--accent-blue);\n  box-shadow: var(--shadow-lg);\n  transform: scale(1.02);\n}\n\n.maintenance-pricing-card h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.maintenance-pricing-card .price {\n  font-size: 2.8rem;\n  font-weight: 700;\n  color: var(--accent-blue);\n  margin-bottom: var(--space-sm);\n}\n\n.maintenance-pricing-card .price span {\n  font-size: 0.9rem;\n  color: var(--gray-600);\n  font-weight: 400;\n}\n\n/* FAQ Section */\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.faq-item {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  transition: all 0.3s ease;\n}\n\n.faq-item:hover {\n  box-shadow: var(--shadow-md);\n  border-color: var(--accent-blue);\n}\n\n.faq-item h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.faq-item p {\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Hourly Rates Section */\n.hourly-rates-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n/* For 5 cards, use 2-3 column layout */\n@media (min-width: 1200px) {\n  .hourly-rates-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 900px) and (max-width: 1199px) {\n  .hourly-rates-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.hourly-rate-card {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-xl);\n  padding: var(--space-xl);\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.hourly-rate-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--accent-blue);\n}\n\n.hourly-rate-card h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.hourly-price {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--accent-blue);\n  margin-bottom: var(--space-sm);\n}\n\n.hourly-price span {\n  font-size: 0.9rem;\n  color: var(--gray-600);\n  font-weight: 400;\n}\n\n.rate-description {\n  color: var(--gray-600);\n  margin-bottom: var(--space-lg);\n  font-size: 0.95rem;\n}\n\n.rate-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.rate-features li {\n  padding: var(--space-xs) 0;\n  color: var(--gray-600);\n  position: relative;\n  padding-left: var(--space-lg);\n}\n\n.rate-features li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: var(--teal);\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .pricing-grid,\n  .dev-pricing-grid,\n  .maintenance-pricing-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n  \n  .pricing-card.featured {\n    transform: none;\n  }\n  \n  .maintenance-pricing-card.featured {\n    transform: none;\n  }\n  \n  .faq-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n  \n  .hourly-rates-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n}\n\n/* Simplified Hourly Rate Section */\n.hourly-rate-simple {\n  display: flex;\n  justify-content: center;\n  margin-top: var(--space-2xl);\n}\n\n.hourly-rate-card-simple {\n  background: var(--white);\n  border: 2px solid var(--accent-blue);\n  border-radius: var(--radius-xl);\n  padding: var(--space-2xl);\n  text-align: center;\n  box-shadow: var(--shadow-lg);\n  max-width: 600px;\n  width: 100%;\n}\n\n.hourly-price-large {\n  font-size: 3.5rem;\n  font-weight: 700;\n  color: var(--accent-blue);\n  margin-bottom: var(--space-md);\n  line-height: 1;\n}\n\n.hourly-price-large span {\n  font-size: 1.5rem;\n  color: var(--gray-600);\n  font-weight: 500;\n}\n\n.rate-description-large {\n  font-size: 1.2rem;\n  color: var(--gray-700);\n  margin-bottom: var(--space-xl);\n  font-weight: 500;\n}\n\n.rate-services-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-lg);\n  margin-top: var(--space-xl);\n}\n\n.service-category {\n  text-align: left;\n  padding: var(--space-md);\n  background: var(--gray-50);\n  border-radius: var(--radius-lg);\n  border-left: 4px solid var(--accent-blue);\n}\n\n.service-category h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-xs);\n}\n\n.service-category p {\n  font-size: 0.95rem;\n  color: var(--gray-600);\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Responsive adjustments for simplified hourly rates */\n@media (max-width: 768px) {\n  .hourly-price-large {\n    font-size: 2.5rem;\n  }\n  \n  .hourly-price-large span {\n    font-size: 1.2rem;\n  }\n  \n  .rate-description-large {\n    font-size: 1.1rem;\n  }\n  \n  .rate-services-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-md);\n  }\n  \n  .hourly-rate-card-simple {\n    padding: var(--space-xl);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
